/**
 * Two short fields side by side inside a `FormSection` from `md` up, one under
 * the other below it (hybrid-3c §12: forms go one column on a phone). A CSS
 * grid rather than MUI's `Grid`: the section's `Stack` resets its children's
 * margins, which strips `Grid container`'s negative gutter and pushes the
 * fields past the card's right edge.
 */

import React from 'react';
import { Box } from '@mui/material';

export interface FieldPairProps {
  /** The two fields (a third wraps onto the next row). */
  children: React.ReactNode;
}

export const FieldPair: React.FC<FieldPairProps> = ({ children }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
      columnGap: 2,
      alignItems: 'start',
    }}
  >
    {children}
  </Box>
);

export default FieldPair;
